<template>
	<div class="dirSubItems-container">
		<Avatar
			v-if="subItem.directory_logo"
			class="dirSubItems-container__avatar"
			:avatar="subItem.directory_logo"
		/>
		<div v-if="subItem.directory_first_row" class="d-flex">
			<span class="dirSubItems-container__title">Company name:</span>
			<span class="dirSubItems-container__description">
				{{ subItem.directory_first_row }}</span
			>
		</div>
		<div v-if="subItem.directory_second_row" class="d-flex">
			<span class="dirSubItems-container__title">Title:</span>
			<span class="dirSubItems-container__description">
				{{ subItem.directory_second_row }}</span
			>
		</div>
		<div v-if="subItem.directory_third_row" class="d-flex">
			<span class="dirSubItems-container__title">Period:</span>
			<span class="dirSubItems-container__description">
				{{ subItem.directory_third_row }}</span
			>
		</div>
		<div
			v-for="social in socialFields"
			v-if="social.value"
			:key="social.field"
			class="d-flex align-center"
		>
			<span class="dirSubItems-container__title">{{ social.title }}:</span>
			<template v-if="['twitter', 'facebook', 'linkedin'].includes(social.field)">
				<a
					:href="getSocialLink(social.field, social.value)"
					class="dirSubItems-container__link text-decoration-none"
					target="_blank"
					rel="noopener noreferrer"
					v-if="social.value"
				>
					{{ social.value }}
				</a>
			</template>
			<template v-else-if="social.field === 'company_email'">
				<a
					:href="'mailto:' + social.value"
					class="dirSubItems-container__email text-decoration-none"
					v-if="social.value"
				>
					{{ social.value }}
				</a>
			</template>
			<template v-else-if="social.field === 'phone'">
				<span
					class="dirSubItems-container__phone"
					style="cursor: pointer; color: var(--accent-color)"
					@click="copyPhone(social.value)"
					v-if="social.value"
				>
					{{ social.value }}
				</span>
			</template>
		</div>
	</div>
</template>
<script>
import Avatar from '@/components/Avatar.vue'
import { mapActions } from 'vuex'

export default {
	name: 'DirectorySubItemPreview',
	components: { Avatar },
	props: {
		subItem: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		socialFields() {
			const socialKeys = ['twitter', 'facebook', 'linkedin', 'phone', 'company_email']
			return (this.subItem.public || []).filter((item) => socialKeys.includes(item.field))
		},
		getSocialLink() {
			return (field, value) => {
				if (!value) return null
				switch (field) {
					case 'twitter':
						return value.startsWith('http') ? value : `https://twitter.com/${value}`
					case 'facebook':
						return value.startsWith('http') ? value : `https://facebook.com/${value}`
					case 'linkedin':
						return value.startsWith('http') ? value : `https://linkedin.com/in/${value}`
					default:
						return value
				}
			}
		},
	},
	methods: {
		...mapActions('app', ['showAlert', 'hideAlert']),
		copyPhone(value) {
			if (!this.isShowAlert) {
				const phone = value.replace(/\D/g, '')
				this.$copyText(phone).then(() => {
					const closeTimeout = setTimeout(() => {
						this.hideAlert('')
					}, 3000)
					this.showAlert({ message: 'Phone number copied successfully.', closeTimeout })
				})
			}
		},
	},
}
</script>

<style lang="scss">
.dirSubItems-container {
	font-family: 'Inter', sans-serif;
	padding: 12px;
	max-width: 555px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	background-color: #ffffff;
	border-radius: 8px;
	border: 1px solid #e2e2e2;

	&__avatar {
		height: 52px;
		width: 52px;
		border-radius: 8px;
	}
	&__title {
		font-weight: 600;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}
	&__phone {
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--link) !important;
		margin-left: 4px;
	}
	&__description {
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
		margin-left: 4px;
	}
	&__link {
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--link) !important;
		margin-left: 4px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		display: inline-block;
	}
	&__email {
		text-decoration: unset;
		font-weight: 400;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		color: var(--link) !important;
		margin-left: 4px;
	}
}
</style>
